import React from "react";
import chunk from "lodash/chunk";
import { DomParser } from "../utils/dom-parser";
import { WidgetBox, Empty, Link, Action } from "../components";
import { renderDate } from "../utils/text-display";

const MyTraining = ({ title = "My Training" }) => {
    const parseDataFromDOM = () => {
        const domParser = new DomParser(
            "table[summary='Required Training Content'] > tbody > tr > td"
        );
        const columns = domParser.columns;
        return chunk(columns, 3)
            .map(row => {
                const [td1, td2, td3] = row;
                const link = domParser.singleAnchor(td1);

                return {
                    link,
                    dueDate: domParser.dateSpan(td2),
                    actions: domParser.multiAnchor(td3)
                };
            })
            .sort((a, b) => a.dueDate - b.dueDate);
    };

    const data = parseDataFromDOM();

    let titleLink = null;
    let titleLinkEl = document.querySelector(
        "div[data-tag='pnlMyTraining'] a.titleLink"
    );

    if (titleLinkEl) {
        titleLink = titleLinkEl.getAttribute("href");
    }

    return (
        <WidgetBox
            title={title}
            type="warning"
            backgroundIcon="books"
            titleLink={titleLink}
        >
            <div className="v-list">
                <Empty isEmpty={data.length === 0} />
                {data.map((o, i) => (
                    <div
                        key={i}
                        className="v-list-item v-list-item--space-between"
                    >
                        <div>
                            <Action classes="v-list-item__title" {...o.link} />
                            <p className="v-list-item__date">
                                {renderDate(o.dueDate, "Due date: ")}
                            </p>
                        </div>
                        <div className="my-training__actions">
                            {o.actions.map((a) => (
                                <Action key={a.actionId} {...a} />
                            ))}
                        </div>
                    </div>
                ))}
            </div>
            {titleLink && <Link text="See all items" url={titleLink} />}
        </WidgetBox>
    );
};

export default MyTraining;



// WEBPACK FOOTER //
// ./src/frontend/components/Blocks/cornerstone-widget-block/widgets/my-training.js